(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RacingTrackerApp", [], factory);
	else if(typeof exports === 'object')
		exports["RacingTrackerApp"] = factory();
	else
		root["RacingTrackerApp"] = factory();
})(self, () => {
return 